import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '@app/public/header/header.component';
import { FooterComponent } from '@app/public/footer/footer.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterLink, HeaderComponent, FooterComponent],
  template: `
    <app-header></app-header>
    <main class="legal-page">
      <div class="container">
        <div class="legal-content">
          <h1>Politique de Confidentialité</h1>
          <p class="last-updated">Dernière mise à jour : 1 Juin 2025</p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              Chez Zero-Waste, nous prenons la protection de vos données
              personnelles très au sérieux. Cette politique de confidentialité
              explique comment nous collectons, utilisons, partageons et
              protégeons vos informations lorsque vous utilisez notre
              application et nos services.
            </p>
          </section>

          <section>
            <h2>2. Informations que nous collectons</h2>
            <p>Nous collectons les types d'informations suivants :</p>
            <ul>
              <li>
                <strong>Informations de compte</strong> : nom, adresse e-mail,
                mot de passe, numéro de téléphone.
              </li>
              <li>
                <strong>Informations de profil</strong> : photo de profil,
                préférences alimentaires.
              </li>
              <li>
                <strong>Données de localisation</strong> : pour vous montrer les
                offres à proximité.
              </li>
              <li>
                <strong>Informations de transaction</strong> : historique
                d'achats, méthodes de paiement.
              </li>
              <li>
                <strong>Données d'utilisation</strong> : interactions avec
                l'application, préférences.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Comment nous utilisons vos informations</h2>
            <p>Nous utilisons vos informations pour :</p>
            <ul>
              <li>Fournir, maintenir et améliorer nos services</li>
              <li>Traiter vos transactions et réservations</li>
              <li>Vous envoyer des notifications importantes</li>
              <li>Personnaliser votre expérience</li>
              <li>Communiquer avec vous concernant nos offres</li>
              <li>Prévenir la fraude et assurer la sécurité</li>
            </ul>
          </section>

          <section>
            <h2>4. Partage des informations</h2>
            <p>Nous pouvons partager vos informations avec :</p>
            <ul>
              <li>
                <strong>Commerçants partenaires</strong> : pour faciliter vos
                réservations et achats
              </li>
              <li>
                <strong>Prestataires de services</strong> : qui nous aident à
                fournir nos services
              </li>
              <li>
                <strong>Autorités légales</strong> : lorsque requis par la loi
              </li>
            </ul>
            <p>Nous ne vendons jamais vos données personnelles à des tiers.</p>
          </section>

          <section>
            <h2>5. Vos droits</h2>
            <p>Vous avez le droit de :</p>
            <ul>
              <li>Accéder à vos données personnelles</li>
              <li>Rectifier vos données inexactes</li>
              <li>Supprimer vos données (droit à l'oubli)</li>
              <li>Limiter le traitement de vos données</li>
              <li>Vous opposer au traitement de vos données</li>
              <li>Demander la portabilité de vos données</li>
            </ul>
            <p>
              Pour exercer ces droits, contactez-nous à
              <a href="mailto:contact@zero-waste.pro"
                >contact&#64;zero-waste.pro</a
              >.
            </p>
          </section>

          <section>
            <h2>6. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité techniques et
              organisationnelles pour protéger vos données contre l'accès non
              autorisé, la perte ou l'altération.
            </p>
          </section>

          <section>
            <h2>7. Conservation des données</h2>
            <p>
              Nous conservons vos données aussi longtemps que nécessaire pour
              fournir nos services ou pour respecter nos obligations légales.
              Vous pouvez demander la suppression de votre compte à tout moment.
            </p>
          </section>

          <section>
            <h2>8. Modifications de cette politique</h2>
            <p>
              Nous pouvons mettre à jour cette politique de confidentialité
              périodiquement. Nous vous informerons de tout changement important
              par e-mail ou via l'application.
            </p>
          </section>

          <section>
            <h2>9. Nous contacter</h2>
            <p>
              Si vous avez des questions concernant cette politique de
              confidentialité, veuillez nous contacter à :
            </p>
            <p>
              Zero-Waste<br />
              42 Rue de l'Écologie<br />
              75001 Paris, France<br />
              <a href="mailto:contact@zero-waste.pro"
                >contact&#64;zero-waste.pro</a
              >
            </p>
          </section>

          <div class="back-link">
            <a [routerLink]="['/']">← Retour à l'accueil</a>
          </div>
        </div>
      </div>
    </main>
    <app-footer></app-footer>
  `,
  styles: [
    `
      .legal-page {
        padding: 120px 0 60px;
        background-color: #f9f9f9;
      }

      .legal-content {
        background-color: var(--white);
        padding: 40px;
        border-radius: 10px;
        box-shadow: var(--shadow);
        max-width: 900px;
        margin: 0 auto;
      }

      h1 {
        color: var(--primary-dark);
        margin-bottom: 10px;
        font-size: 2.5rem;
      }

      .last-updated {
        color: var(--light-text);
        font-style: italic;
        margin-bottom: 30px;
      }

      section {
        margin-bottom: 30px;
      }

      h2 {
        color: var(--primary-color);
        margin-bottom: 15px;
        font-size: 1.5rem;
      }

      p,
      ul {
        margin-bottom: 15px;
        line-height: 1.6;
      }

      ul {
        padding-left: 20px;
      }

      li {
        margin-bottom: 8px;
      }

      a {
        color: var(--primary-color);
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }

      .back-link {
        margin-top: 40px;
        padding-top: 20px;
        border-top: 1px solid #eee;
      }

      .back-link a {
        display: inline-block;
        font-weight: 500;
      }

      @media (max-width: 768px) {
        .legal-page {
          padding: 100px 0 40px;
        }

        .legal-content {
          padding: 25px;
        }

        h1 {
          font-size: 2rem;
        }
      }
    `,
  ],
})
export class PrivacyPolicyComponent {}
